import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Button, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import * as eidAppointmentActions from '../../Redux/Actions/eidAppointmentDetails';
import { toastMessage } from '../../utils/toast';

const EditEidAppointment = ({ history }) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({ applicationNo: '', name: '', phoneNumber: '', email: '', gender: '' });

    useEffect(() => {
        if (id) {
            setLoading(true);
            eidAppointmentActions.EidAppointmentGetById(id).then(res => {
                if (res && res.data) {
                    const d = res.data;
                    setForm({
                        applicationNo: d.applicationNo || null,
                        name: d.name || null,
                        phoneNumber: d.phoneNo || null,
                        email: d.email || null,
                        gender: d.gender || null
                    });
                } else {
                    toastMessage('error', res?.message || 'Unable to load appointment');
                }
                setLoading(false);
            }).catch(() => {
                setLoading(false);
                toastMessage('error', 'Unable to load appointment');
            });
        }
    }, [id]);

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!form.name || !form.phoneNumber) {
            toastMessage('error', 'Name and phone number are required');
            return;
        }
        setLoading(true);
        eidAppointmentActions.EidAppointmentEdit({ id, ...form }).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Appointment saved successfully');
                history.push('/eid-appointment-details');
            } else {
                toastMessage('error', res?.message || 'Save failed');
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
            toastMessage('error', 'Save failed');
        });
    };

    return (
        <div className="container-fluid mt-3">
            <div className="page-title-box">
                <h4 className="page-title my-2">{t('eidAppointmentDetails.manageEidAppointment.edit') || 'Edit EID Appointment'}</h4>
            </div>
            <Card>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="applicationNo">
                            <Form.Label>{t('eidAppointmentDetails.manageEidAppointment.applicationNo') || 'Application No'}</Form.Label>
                            <Form.Control name="applicationNo" value={form.applicationNo} onChange={handleChange} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label>{t('eidAppointmentDetails.manageEidAppointment.name') || 'Name'}</Form.Label>
                            <Form.Control name="name" value={form.name} onChange={handleChange} required />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="phoneNumber">
                            <Form.Label>{t('eidAppointmentDetails.manageEidAppointment.phoneNumber') || 'Phone Number'}</Form.Label>
                            <Form.Control name="phoneNumber" value={form.phoneNumber} onChange={handleChange} required />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="email">
                            <Form.Label>{t('eidAppointmentDetails.manageEidAppointment.email') || 'Email'}</Form.Label>
                            <Form.Control name="email" value={form.email} onChange={handleChange} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="gender">
                            <Form.Label>{t('eidAppointmentDetails.manageEidAppointment.gender') || 'Gender'}</Form.Label>
                            <Form.Select name="gender" value={form.gender} onChange={handleChange}>
                                <option value="">{t('eidAppointmentDetails.filters.selectGender') || 'Select'}</option>
                                <option value="Male">{t('eidAppointmentDetails.filters.male') || 'Male'}</option>
                                <option value="Female">{t('eidAppointmentDetails.filters.female') || 'Female'}</option>
                            </Form.Select>
                        </Form.Group>

                        <div className="d-flex justify-content-end">
                            <Button variant="secondary" className="me-2" onClick={() => history.push('/eid-appointment-details')}> {t('eidAppointmentDetails.manageEidAppointment.cancel') || 'Cancel'} </Button>
                            <Button variant="primary" type="submit" disabled={loading}>{loading ? t('common.saving') || 'Saving...' : t('eidAppointmentDetails.manageEidAppointment.save') || 'Save'}</Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default EditEidAppointment;
